import React, {useEffect, useState} from "react";
import {Col, Form, Row} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import {notification} from "antd";
import SelectField from "../../../components/common/select-field/SelectField";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import DescriptionField from "../../../components/common/description-field/DescriptionField";
import {CloseRoundedCheck, RoundedCheck} from "../../../../assets/icons/defaultIcons";
import {checkEmptySpaces, maxLength, Required} from "../../../utils/patterns";
import {AddWeekTargets} from "../../../services/target-api.service";
import {getWeekStartEnd, getWeekStartDate} from "../../../utils/helper";

export default function AddWeeklyTargets({
                                             close,
                                             getListing,
                                             setGetListing,
                                             setValuee,
                                             goalSelectedCategroy,
                                             weekOptions,
                                             setGoalSelectedCategory,
                                             monthOptions,
                                             selectedCategory,
                                             quarter,
                                             year,
                                             selectedMonth,
                                             duplicateData
                                         }) {
    const [loader, setLoader] = useState(false);
    const [selectedMonths, setSelectedMonths] = useState(selectedMonth);
    const [weekSelect, setWeekSelect] = useState([]);
    
    console.log('AddWeeklyTargets received duplicateData:', duplicateData);
    
    const {
        handleSubmit,
        reset,
        formState: { errors },
        control,
        setValue,
        watch
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            month: duplicateData?.month || selectedMonth || '',
            week: duplicateData?.weekNumber || '',
            des: duplicateData?.title || '',
            category: duplicateData?.category || ''
        }
    });

    const navigate = useNavigate();

    const onSubmit = async (data) => {        let payload = {
            quarter: parseInt(quarter),
            weekNumber: parseInt(data.week),
            month: parseInt(data.month),
            year: year,
            title: data.des,
            category: selectedCategory === "" ? data.category : selectedCategory,
            typeValue: getWeekStartDate(parseInt(data.month), parseInt(data.week), year)
        };

        console.log(payload, 'data month');

        setLoader(true);

        try {
            const response = await AddWeekTargets(payload);

            if (response?.data?.data?.status) {
                notification.success({
                    message: "Success",
                    description: "Weekly Target added Successfully",
                    placement: "topRight",
                    icon: <RoundedCheck />,
                    duration: 2,
                });
                setLoader(false);
                reset();
                setGetListing(prev => !prev);
                close(false);
            } else {
                throw new Error("Submission failed");
            }
        } catch (err) {
            notification.error({
                message: "Failed",
                description: "Weekly Target Failed to Add",
                placement: "topRight",
                icon: <CloseRoundedCheck />,
                duration: 2,
            });
            setLoader(false);
        }
    };

    // Generate week options with date range
    function generateWeekOptions(month, year, weekCount) {
        const weekOptionss = [];
        for (let weekNumber = 1; weekNumber <= weekCount; weekNumber++) {
            const weekRange = getWeekStartEnd(month, weekNumber, year);
            weekOptionss.push({
                value: String(weekNumber),
                label: `${weekNumber} Week (${weekRange})`
            });
        }
        return weekOptionss;
    }

    const watchMonth = watch("month");

    useEffect(() => {
        if (watchMonth) {
            setSelectedMonths(watchMonth);
            setValue("week", ""); // ✅ Clear week when month changes
        }
    }, [watchMonth, setValue]);

    useEffect(() => {
        if (selectedMonths && weekOptions?.[0]?.weekly?.length > 0) {
            const generated = generateWeekOptions(selectedMonths, year, weekOptions[0].weekly.length);
            setWeekSelect(generated);
        }
    }, [selectedMonths, weekOptions, year]);

    // Handle duplicate data population
    useEffect(() => {
        if (duplicateData) {
            console.log('Processing duplicate data in weekly targets:', duplicateData);
            if (duplicateData.month) {
                setValue("month", duplicateData.month.toString());
                setSelectedMonths(duplicateData.month.toString());
            }
            if (duplicateData.weekNumber) {
                setValue("week", duplicateData.weekNumber.toString());
            }
            if (duplicateData.title) {
                console.log('Setting weekly title:', duplicateData.title);
                setValue("des", duplicateData.title);
            }
            if (duplicateData.category) {
                console.log('Setting weekly category:', duplicateData.category);
                setValue("category", duplicateData.category);
            }
        }
    }, [duplicateData, setValue]);

    return (
        <div className={'add-gratitude'}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col md={6}>
                        <div className={"dfields"}>
                            <Controller
                                name="month"
                                control={control}
                                rules={{ required: Required }}
                                defaultValue={selectedMonth || ''}
                                render={({ field, value }) => (
                                    <SelectField
                                        showSearch={true}
                                        label={"Select Month"}
                                        field={field}
                                        defaultValue={selectedMonth || ''}
                                        placeholder={"Select Month"}
                                        className={"required"}
                                        options={monthOptions}
                                        fieldName={field.name}
                                        setValue={setValue}
                                        errors={errors.month}
                                    />
                                )}
                            />
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className={"dfields"}>
                            <Controller
                                name="week"
                                control={control}
                                rules={{ required: Required }}
                                render={({ field }) => (
                                    <SelectField
                                        showSearch={true}
                                        label={"Select Week"}
                                        field={field}
                                        value={field.value}
                                        placeholder={"Select Week"}
                                        className={"required"}
                                        options={weekSelect}
                                        fieldName={field.name}
                                        setValue={setValue}
                                        errors={errors.week}
                                    />
                                )}
                            />
                        </div>
                    </Col>                    {(selectedCategory === "" || duplicateData) && (
                        <Col md={12}>
                            <div className={"dfields"}>
                                <Controller
                                    name="category"
                                    control={control}
                                    defaultValue={duplicateData?.category || ""}
                                    rules={{ required: Required }}
                                    render={({ field }) => (
                                        <SelectField
                                            showSearch={true}
                                            label={"Select Category"}
                                            field={field}
                                            placeholder={"Select Category"}
                                            className={"required"}
                                            options={[
                                                { value: "Faith", label: "Faith" },
                                                { value: "Family", label: "Family" },
                                                { value: "Fitness", label: "Fitness" },
                                                { value: "Finance", label: "Finance" },
                                            ]}
                                            fieldName={field.name}
                                            setValue={setValue}
                                            errors={errors.category}
                                            value={duplicateData ? duplicateData.category : field.value}
                                        />
                                    )}
                                />
                            </div>
                        </Col>
                    )}
                    <Col md={12}>
                        <div className={'dfields'}>
                            <Controller
                                name="des"
                                defaultValue={''}
                                control={control}
                                rules={{
                                    required: Required,
                                    maxLength: maxLength(2000),
                                    validate: checkEmptySpaces
                                }}
                                render={({ field: { name, ...field } }) => (
                                    <DescriptionField
                                        placeholder={'Write your weekly quest here'}
                                        type={'text'}
                                        defaultValue={field.value}
                                        field={field}
                                        className={'required'}
                                        errors={errors.des}
                                        autoSize={{ minRows: 1, maxRows: 1 }}
                                        label={'Write your Weekly Quest '}
                                    />
                                )}
                            />
                        </div>
                    </Col>
                    <Col md={12}>
                        <div className={'mt-30'}>
                            <ThemeButton
                                text={'Add'}
                                type={'submit'}
                                className={'btn-light-lg'}
                                loader={loader}
                            />
                        </div>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}
